import { css } from 'styled-components';

const createBreakpoint = (width) => (styles) => css`@media (min-width: ${width}) {
  ${styles}
}`;

export default createBreakpoint;
